import { CSSProperties, FC, memo, useEffect, useState } from 'react'
import classNames from 'classnames'

import css from './CustomCursorWork.module.scss'

import useLayout from '@/hooks/use-layout'

import LeftArrow from '@/svgs/left-arrow.svg'
import RightArrow from '@/svgs/right-arrow.svg'

export type CustomCursorWorkProps = {
  className?: string
  text?: string
  handleClickLeft?: () => void
  handleClickRight?: () => void
}

const CustomCursorWork: FC<CustomCursorWorkProps> = ({ className, handleClickLeft, handleClickRight }) => {
  const [cursorPosition, setCursorPosition] = useState<{ x: number; y: number } | null>(null)
  const [visibleCursor, setVisibleCursor] = useState('none')
  const layout = useLayout()

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      setCursorPosition({ x: e.clientX, y: e.clientY })

      if (target.classList.contains('CursorLeftWork')) {
        setVisibleCursor('left')
      } else if (target.classList.contains('CursorRightWork')) {
        setVisibleCursor('right')
      } else {
        setVisibleCursor('none')
      }
    }

    document.addEventListener('mousemove', handleMouseMove)

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
    }
  }, [])

  useEffect(() => {
    if (layout.device) return

    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement

      if (target.classList.contains('CursorLeftWork')) {
        handleClickLeft?.()
      } else if (target.classList.contains('CursorRightWork')) {
        handleClickRight?.()
      }
    }

    document.addEventListener('click', handleClick)

    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [layout, handleClickLeft, handleClickRight])

  return (
    <div
      className={classNames('CustomCursorWork', css.root, className, {
        [css.left]: visibleCursor === 'left',
        [css.right]: visibleCursor === 'right'
      })}
      style={{ '--x': `${cursorPosition?.x ?? 0}px`, '--y': `${cursorPosition?.y ?? 0}px` } as CSSProperties}
    >
      <div className={css.positionWrapper}>
        <div className={css.buttonsWrapper}>
          <div className={classNames(css.button, css.leftButton)}>
            <LeftArrow className={css.svg} />
          </div>
          <div className={classNames(css.button, css.rightButton)}>
            <RightArrow className={css.svg} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(CustomCursorWork)
